<template>
    <div class="abschluss-erfolgreich-box px-4 py-5 p-md-5 d-flex flex-column justify-content-center align-items-center">
        <grosser_haken_icon></grosser_haken_icon>
        <div class="mt-5 mb-4">
            <b>Die E-Mailadresse wurde erfolgreich verifiziert.</b>

        </div>

        <div class="abschluss-erfolgreich-info-box px-4 py-3 px-md-5 py-md-4">
            <div class="d-flex flex-row pb-3">
                <span class="me-3">
                    <info_icon_blau></info_icon_blau>
                </span>
                <div>
                    <b>Bitte beachten Sie:</b>
                </div>
            </div>
            Der Versicherungsschein wurde bei Abschluss bereits automatisch erstellt und heruntergeladen. Bitte prüfen Sie Ihren Download-Ordner.
            Sie erhalten den Versicherungsschein auch gleich per E-Mail. Prüfen Sie bitte Ihren Posteingang. Das Passwort zum Öffnen der PDF-Datei ist Ihre Postleitzahl.
        </div>

        <div class="font-lg-links mt-4">
            <b>Hinweis:</b><br>
            Mit dieser Bestätigung Ihrer E-Mailadresse erhalten Sie den Versicherungsschein auch per E-Mail. Prüfen Sie Ihren Posteingang. 
            Das Passwort zum Öffnen der PDF-Datei ist Ihre Postleitzahl.
        </div>
    </div> 
</template>

<script setup>
import grosser_haken_icon from './icons/grosser_haken_icon.vue';
import info_icon_blau from './icons/info_icon_blau.vue';
</script>